// src/pages/ForgotPassword.js
import { useState, useEffect } from "react";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await apiClient.post("/auth/forgot-password", { email });
      toast.success("Reset link sent! Check your email.");
    } catch (err) {
      toast.error("Could not send reset email.");
    }
  };
  
  const [keyboardOffset, setKeyboardOffset] = useState(0);
  // Keyboard Event Handling for Android
  useEffect(() => {
    if (Capacitor.getPlatform() === 'android') {
      const showSub = Keyboard.addListener('keyboardWillShow', (info) => {
        setKeyboardOffset(info.keyboardHeight || 300); // fallback height
      });
      const hideSub = Keyboard.addListener('keyboardWillHide', () => {
        setKeyboardOffset(0);
      });

      return () => {
        showSub.remove();
        hideSub.remove();
      };
    }
  }, []);

  return (
<>
<div
  className="min-h-[100dvh] bg-cover bg-center flex flex-col text-center font-sans"
  style={{ backgroundImage: "url('assets/splash-1.jpg')" }}
>
  <h1 className="text-5xl font-light tracking-tight text-[#1F2937] pt-8 pb-4">Sous</h1>

  <div className="flex-1 flex items-center justify-center overflow-y-auto px-4 py-8" style={{ paddingBottom: `${keyboardOffset}px` }}>
    <div className="bg-white backdrop-blur-sm rounded-xl md:rounded-xl p-4 m-4 max-w-xl w-full space-y-6 shadow-lg">
      <h2 className="text-xl font-semibold">Resest your password</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          inputMode="email" 
          autoComplete="email"
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />
        <button
          type="submit"
          className="w-full bg-sage text-white py-2 rounded-3xl hover:bg-sagedark"
        >
          Send Reset Link
        </button>
      </form>
    </div>
  </div>
</div>
</>
  );
}
